import { getPartnerRequests } from "helpers/api_helper"
import { all, put, takeEvery } from "redux-saga/effects"
import {
  getPartnerRequestsFailed,
  getPartnerRequestsSuccess,
} from "./actions"
import { partnerRequestActionTypes } from "./actions"

function* getPartnerRequestsSaga({ payload }) {
  try {
    const response = yield getPartnerRequests(payload)
    yield put(getPartnerRequestsSuccess(response))
  } catch (e) {
    console.log("error-----", e)
    yield put(getPartnerRequestsFailed(e.response?.status))
  }
}

export default function* partnerRequestSaga() {
  yield all([
    takeEvery(partnerRequestActionTypes.GET_PARTNER_REQUESTS_REQUEST, getPartnerRequestsSaga),
  ])
}
